/* Básculas de Santander: encabezado compacto y tarjetas de producto */
(function () {
  'use strict';

  var WA_NUMBER = '573158828985';
  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35m-5.42 7.4h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.89-9.88 9.89m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.17-3.48-8.41Z"/></svg>';

  /* Encabezado compacto al bajar, con margen para evitar saltos */
  var body = document.body;
  var compact = false;
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (!compact && y > 140) {
      compact = true;
      body.classList.add('bs-scrolled');
    } else if (compact && y < 60) {
      compact = false;
      body.classList.remove('bs-scrolled');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Tarjetas: sello OIML y botón de cotizar por WhatsApp */
  function enhance(card) {
    if (!card || card.getAttribute('data-bs-done')) return;
    var link = card.querySelector('.product-item__title');
    if (!link) return;
    card.setAttribute('data-bs-done', '1');

    var title = (link.textContent || '').replace(/\s+/g, ' ').trim();
    var href = link.getAttribute('href') || '';
    var url = link.href || window.location.href;

    if (/oiml/i.test(title) || /oiml/i.test(href)) {
      var labels = card.querySelector('.product-item__label-list');
      if (!labels) {
        labels = document.createElement('div');
        labels.className = 'product-item__label-list';
        card.insertBefore(labels, card.firstChild);
      }
      if (!labels.querySelector('.bs-label-oiml')) {
        var badge = document.createElement('span');
        badge.className = 'product-label bs-label-oiml';
        badge.textContent = 'Certificada OIML';
        labels.appendChild(badge);
      }
    }

    var quote = document.createElement('a');
    quote.className = 'bs-cotizar';
    quote.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent('Hola, quiero cotizar: ' + title + ' ' + url);
    quote.target = '_blank';
    quote.rel = 'noopener';
    quote.setAttribute('aria-label', 'Cotizar por WhatsApp: ' + title);
    quote.innerHTML = WA_ICON + '<span>Cotizar</span>';

    var actions = card.querySelector('.product-item__action-list');
    if (actions) {
      actions.classList.add('bs-actions');
      actions.insertBefore(quote, actions.firstChild);
    } else {
      var row = document.createElement('div');
      row.className = 'bs-actions';
      row.appendChild(quote);
      (card.querySelector('.product-item__info') || card).appendChild(row);
    }
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll('.product-item');
    for (var i = 0; i < cards.length; i++) enhance(cards[i]);
  }

  scan(document);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('product-item')) enhance(node);
          else if (node.querySelectorAll) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();